import React, { useState, useEffect } from 'react';
import { Select, Table, Switch } from 'antd';
import PropTypes from 'prop-types';
import { parseColumnsForRunInstanceResultListing } from './utils';
import { SearchSortAndFilter } from '../../../../components/ns/SearchSortAndFilter';
import Wait4Me from '../../../../components/Wait4Me';
import { ALERT_SOURCE_MAPPING } from '../../../../util/GlobalConstant';
import styles from './index.scss';
import {
  getAttributeByResourceCode,
  displaySwitchForTSNS,
  getModuleTypeByResourceCode
} from '../../../../util/miscellaneousUtils';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../constants/globalConstants';
import { convertDateInputToEpoch } from '../../../../util/timezone';
import { isEmpty } from 'lodash';

const alertResourceCode = 'APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS';

export const RunInstanceResult = ({
  runInstanceResultList,
  apiActions,
  GS,
  widgetItemOperations,
  moduleTypeHandler,
  moduleType,
  authentication,
  settings
}) => {
  const { getNSRunInstanceResultListData, getPageItemOperations } = apiActions;
  const { isLoading, data } = runInstanceResultList;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [extraQueryParameter, setExtraQueryParameter] = useState({
    filter: [],
    search: []
  });
  const [selectedModule, setSelectedModule] = useState('');

  useEffect(() => {
    if (
      moduleType === ALERT_SOURCE_MAPPING.NS ||
      moduleType === ALERT_SOURCE_MAPPING.PS ||
      moduleType === ALERT_SOURCE_MAPPING.PSRS
    )
      getNSRunInstanceResultListData({
        sourceIds: `${
          moduleType == ALERT_SOURCE_MAPPING.PSRS
            ? ALERT_SOURCE_MAPPING.PS
            : moduleType
        },`,
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        from: extraQueryParameter?.from
          ? convertDateInputToEpoch(extraQueryParameter?.from)
          : null,
        to: extraQueryParameter?.to
          ? convertDateInputToEpoch(extraQueryParameter?.to)
          : null,
        q: btoa(
          JSON.stringify({
            filter: [
              ...extraQueryParameter.filter,
              ...extraQueryParameter.search
            ],
            sort: extraQueryParameter?.sort
          })
        )
      });
    else {
      getNSRunInstanceResultListData({
        sourceIds: `${moduleType},`,
        offset: (currentPage - 1) * pageSize,
        limit: pageSize
      });
    }
  }, [pageSize, currentPage, extraQueryParameter, moduleType]);

  useEffect(() => {
    if (
      moduleType == ALERT_SOURCE_MAPPING.NS ||
      moduleType == ALERT_SOURCE_MAPPING.PS ||
      moduleType === ALERT_SOURCE_MAPPING.PSRS
    ) {
      getPageItemOperations({
        pageId: 'NS_IAD_ALERTS_LIST'
      });
    }
  }, []);

  const onPaginationChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  const alertIdClickHandler = (alertId) => {
    apiActions.navigateTo(
      `${ROUTE_AMLS_SMART_SCREENING}/investigation/${alertId}`,
      {
        sourceId: moduleType
      }
    );
  };

  const columns = parseColumnsForRunInstanceResultListing(
    GS && GS.widgetConfig,
    alertIdClickHandler
  );

  const applyFilterHandler = (obj) => {
    setCurrentPage(1);
    setPageSize(5);
    let operatedQueryObj = {};
    // if (obj?.filter && extraQueryParameter?.filter) {
    //   let previousQueryParameter = { ...extraQueryParameter };
    //   if (obj?.filter?.length && previousQueryParameter?.filter?.length) {
    //     obj.filter.forEach((item) => {
    //       previousQueryParameter['filter'] = previousQueryParameter[
    //         'filter'
    //       ].filter((p) => p.columnName !== item.columnName);
    //     });
    //   }
    //   operatedQueryObj = {
    //     ...previousQueryParameter,
    //     ...obj,
    //     filter: ([...previousQueryParameter?.filter, ...obj?.filter]).filter((ele) => ele.value.trim() !== '')
    //   };
    // } else operatedQueryObj = { ...extraQueryParameter, ...obj };

    // determine if search is empty by checking search key for anything,
    // but let's check first if previous submitted extraQueryParameter has something to search
    let previousQueryParameterHasSearch = false;
    if (
      Array.isArray(previousQueryParameterHasSearch?.search) &&
      previousQueryParameterHasSearch?.search.length > 0
    ) {
      previousQueryParameterHasSearch = true;
    }

    // now let's check for anything to search on provided by the current passed object
    let hasSearch = false;
    if (Array.isArray(obj?.search) && obj?.search.length > 0) {
      hasSearch = true;
    }

    // we check if search is triggered
    let isSearchTriggered = false;
    if (obj?.search) {
      isSearchTriggered = true;
    }

    // if search is triggered, we take the latest search
    if (isSearchTriggered) {
      // if search has something, append to the prev query params,
      // else, use the old query params and don't include prev search
      if (hasSearch) {
        operatedQueryObj = {
          ...extraQueryParameter,
          search: obj?.search
        };
      } else {
        operatedQueryObj = {
          ...extraQueryParameter,
          search: []
        };
      }

      // else, we just replace the filter with the new ones
    } else {
      operatedQueryObj = {
        ...extraQueryParameter,
        ...obj
      };
    }

    setExtraQueryParameter(operatedQueryObj);
  };

  const renderLoadingBlock = () => {
    return (
      <div className={styles.loadingWrapper}>
        <Wait4Me />
      </div>
    );
  };

  const moduleToggleHandler = (value) => {
    moduleTypeHandler(value);
  };

  const renderFilter = () => {
    if (widgetItemOperations?.isLoading) renderLoadingBlock();
    else
      return (
        widgetItemOperations?.data !== null && (
          <SearchSortAndFilter
            applyFilterHandler={applyFilterHandler}
            widgetItemOperations={widgetItemOperations}
          />
        )
      );
  };

  const modulesList = getModuleTypeByResourceCode(
    authentication,
    alertResourceCode
  );

  useEffect(() => {
    if (moduleType && modulesList?.length) {
      let validateModule = modulesList.find((m) => m.value === moduleType);
      setSelectedModule(isEmpty(validateModule) ? '' : validateModule?.value);
    }
  }, [moduleType, modulesList]);

  return (
    <div className={styles.runInstanceResult_wrapper}>
      <div className={styles.runInstanceResult_header}>
        <h3>Run Instance Result</h3>

        {displaySwitchForTSNS(authentication, alertResourceCode) ? (
          <Switch
            checkedChildren="Name"
            unCheckedChildren="Transaction"
            checked={moduleType === ALERT_SOURCE_MAPPING.NS ? true : false}
            onChange={moduleToggleHandler}
            disabled={
              getAttributeByResourceCode(authentication, alertResourceCode) !==
              '7,9'
            }
          />
        ) : (
          <Select
            value={selectedModule}
            placeholder="Please Select"
            onChange={moduleToggleHandler}
            style={{ paddingLeft: '15px', minWidth: '220px' }}>
            {modulesList?.map((module, index) => {
              if (module.value == '17') return;
              return (
                <Select.Option key={index} value={module.value}>
                  {module.label}
                </Select.Option>
              );
            })}
          </Select>
        )}
      </div>

      {settings?.nsSetting?.isLoading
        ? renderLoadingBlock()
        : GS?.isVisible && (
            <React.Fragment>
              {moduleType === ALERT_SOURCE_MAPPING.NS && renderFilter()}
              {moduleType === ALERT_SOURCE_MAPPING.PS && renderFilter()}
              {moduleType === ALERT_SOURCE_MAPPING.PSRS && renderFilter()}
              <Table
                id="runInstanceResultListing"
                className={styles.table}
                dataSource={data?.payload}
                columns={columns}
                loading={isLoading}
                rowKey="alertId"
                pagination={{
                  showSizeChanger: true,
                  responsive: false,
                  total: data?.total,
                  current: currentPage,
                  pageSize,
                  onChange: onPaginationChange,
                  pageSizeOptions: [5, 10, 25, 50, 100],
                  showTotal: (total) => `${total} Records`
                }}
                scroll={{ y: 270 }}
              />
            </React.Fragment>
          )}
    </div>
  );
};

RunInstanceResult.propTypes = {
  apiActions: PropTypes.object.isRequired,
  GS: PropTypes.object,
  runInstanceResultList: PropTypes.object.isRequired,
  widgetItemOperations: PropTypes.object,
  moduleTypeHandler: PropTypes.func,
  moduleType: PropTypes.string
};

export default RunInstanceResult;
